import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { googleKeyErrorSelector, hasGoogleAccessSelector } from '../features/user/UserSlice';

import {
    Grid, Button, Typography
} from '@mui/material';


import AdminMainModal from '../components/admin/AdminMainModal';
import MapToolbar from '../components/map/MapToolbar';
import OpenstreetmapInstance from '../components/map/osm/OpenstreetmapInstance';
import SecuredRoutes from '../components/SecuredRoutes';


const OSMLandingPage = ({ showMapToolBar, isAdmin, adminOpen, handleAdminClose, dimentions }) => {
    const keyError = useSelector(googleKeyErrorSelector);
    const hasGoogleAccess = useSelector(hasGoogleAccessSelector);
    const [timeLeft, setTimeLeft] = useState(20);

    useEffect(() => {
        if (!timeLeft) return;
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);

        return () => {
            clearInterval(intervalId);
        }
    }, [timeLeft]);


    return (
        <div>
            {
                timeLeft > 0 && hasGoogleAccess === 1 && keyError ?
                    <div style={{ marginLeft: '50px', marginTop: '50px', height: '600px', width: '800px' }}>
                        <Grid container spacing={4}>
                            <Grid item sm={12}>
                                <Typography variant="h4">
                                    <b>Google Maps is not available</b>
                                </Typography>
                                <br />
                                <Typography variant="body1">
                                    {keyError}
                                </Typography>
                            </Grid>
                            <Grid item sm={12}>
                                <Typography variant="h6">
                                    <b>Option 1</b>
                                </Typography>
                                <Button variant="outlined" color="primary" onClick={() => setTimeLeft(0)}>
                                    <b>Continue with Openstreet Maps</b>
                                </Button>
                                <br />
                                <Typography variant="subtitle2">
                                    ...autoloading in {timeLeft} seconds
                                </Typography>
                                <br />
                                <br />
                            </Grid>
                            <Grid item sm={12} style={{ backgroundColor: 'Ivory', border: "1px solid grey", }}>
                                <Typography variant="h6">
                                    <b>Option 2</b> (<span style={{ color: 'dodgerblue' }}>Recommended</span>)
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                    Up to 28,000 free map loads per month
                                </Typography>
                                <br />
                                <Typography variant="body1">
                                    <b><a href="https://mapsplatform.google.com/">Get your own Google Maps key,</a></b> and we will add it to your account
                                </Typography>
                                <br />
                                <br />
                            </Grid>
                            <Grid item sm={12}>
                                <Typography variant="h6">
                                    <b>Option 3</b>
                                </Typography>
                                <br />
                                <Typography variant="body1">
                                    Buy Google Map credits from us at ₹ 1 per map loads
                                </Typography>
                                <Typography variant="body1">
                                    Minimum purchase amount: ₹ 500
                                </Typography>
                            </Grid>

                            <Grid item sm={12}>
                                <Typography variant="h4">
                                    Support: +91 93728 00056
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                    :
                    <Fragment >
                        <OpenstreetmapInstance />
                        <SecuredRoutes style={{ zIndex: 401 }} />
                        {
                            showMapToolBar &&
                            <div style={dimentions.rightToolbar}>
                                <MapToolbar style={{ zIndex: 401 }} />
                            </div>
                        }
                        {
                            isAdmin && <AdminMainModal adminOpen={adminOpen} handleAdminClose={handleAdminClose} style={{ zIndex: 401 }} />
                        }
                    </Fragment>
            }
        </div>
    );
}

export default OSMLandingPage;
